/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Eu_Ai_DescInputs */

const en_landing_feature_eu_ai_desc = /** @type {(inputs: Landing_Feature_Eu_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by Mistral, built in Paris. No API key needed — AI works out of the box.`)
};

const de_landing_feature_eu_ai_desc = /** @type {(inputs: Landing_Feature_Eu_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angetrieben von Mistral, entwickelt in Paris. Kein API-Schluessel noetig — KI funktioniert sofort.`)
};

const fr_landing_feature_eu_ai_desc = /** @type {(inputs: Landing_Feature_Eu_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propulsé par Mistral, conçu à Paris. Aucune clé API requise — l'IA fonctionne immédiatement.`)
};

const es_landing_feature_eu_ai_desc = /** @type {(inputs: Landing_Feature_Eu_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulsado por Mistral, creado en París. Sin clave API necesaria — la IA funciona de inmediato.`)
};

const it_landing_feature_eu_ai_desc = /** @type {(inputs: Landing_Feature_Eu_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alimentato da Mistral, creato a Parigi. Nessuna chiave API necessaria — l'IA funziona subito.`)
};

const nl_landing_feature_eu_ai_desc = /** @type {(inputs: Landing_Feature_Eu_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangedreven door Mistral, gebouwd in Parijs. Geen API-sleutel nodig — AI werkt direct.`)
};

const pl_landing_feature_eu_ai_desc = /** @type {(inputs: Landing_Feature_Eu_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zasilane przez Mistral, stworzone w Paryz. Klucz API nie jest potrzebny — AI dziala od razu.`)
};

const fi_landing_feature_eu_ai_desc = /** @type {(inputs: Landing_Feature_Eu_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistralin voimalla, rakennettu Pariisissa. API-avainta ei tarvita — tekoaely toimii heti.`)
};

const da_landing_feature_eu_ai_desc = /** @type {(inputs: Landing_Feature_Eu_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drevet af Mistral, bygget i Paris. Ingen API-nogle nodvendig — AI virker med det samme.`)
};

const sv_landing_feature_eu_ai_desc = /** @type {(inputs: Landing_Feature_Eu_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drivet av Mistral, byggt i Paris. Ingen API-nyckel behovs — AI fungerar direkt.`)
};

/**
* | output |
* | --- |
* | "Powered by Mistral, built in Paris. No API key needed — AI works out of the box." |
*
* @param {Landing_Feature_Eu_Ai_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_eu_ai_desc = /** @type {((inputs?: Landing_Feature_Eu_Ai_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Eu_Ai_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_eu_ai_desc(inputs)
	if (locale === "fr") return fr_landing_feature_eu_ai_desc(inputs)
	if (locale === "es") return es_landing_feature_eu_ai_desc(inputs)
	if (locale === "it") return it_landing_feature_eu_ai_desc(inputs)
	if (locale === "nl") return nl_landing_feature_eu_ai_desc(inputs)
	if (locale === "pl") return pl_landing_feature_eu_ai_desc(inputs)
	if (locale === "fi") return fi_landing_feature_eu_ai_desc(inputs)
	if (locale === "da") return da_landing_feature_eu_ai_desc(inputs)
	if (locale === "sv") return sv_landing_feature_eu_ai_desc(inputs)
	return en_landing_feature_eu_ai_desc(inputs)
});